<template>
  <TrainerLayout>
    <section class="">
      <div v-if="deleteCoursePopUp">
        <ConfirmationAlert
          @sessionDeleteModalEvent="openConfrimDeletePopUp"
          :message="message"
        />
      </div>
      <section>
        <div class="flex items-center justify-between mb-8">
          <h1 class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight">Class Pack Details</h1>
          <ul class="flex items-center"
            v-for="c in trainerCourseView.course &&
            trainerCourseView.course.details"
            :key="c.id">
            <li
              class="mr-2 flex items-center ring-1 ring-gray-300 p-1 rounded-lg cursor-pointer hover:bg-blue-lightest"
              v-if="trainerCourseView.is_booked == 0"
            >
              <button @click="handleCourseDel(c.id)" title="Delete Class Pack">
                <Trash classStr="text-gray-dark" />
              </button>
            </li>
            <li
              class="mr-2 flex items-center ring-1 ring-gray-300 p-1 rounded-lg cursor-pointer hover:bg-blue-lightest"
              v-else
            >
              <button title="Disabled: This Class Pack is currently active.">
                <Trash classStr="text-gray-darkest" />
              </button>
            </li>
            <li
              class="mr-2 flex items-center ring-1 ring-gray-300 p-1 rounded-lg cursor-pointer hover:bg-blue-lightest"
              title="Edit Class Pack"
              v-if="trainerCourseView.is_booked == 0"
            >
              <router-link :to="{ name: 'CourseEdit', params: { id: c.id } }">
                <Pencil classStr="text-gray-dark" />
              </router-link>
            </li>
            <li
              class="mr-2 flex items-center ring-1 ring-gray-300 p-1 rounded-lg cursor-pointer hover:bg-blue-lightest"
              v-else
            >
              <button title="Disabled: This Class Pack is currently active.">
                <Pencil classStr="text-gray-darkest" />
              </button>
            </li>
          </ul>
        </div>
        <SessionThumbnailSupporting
          :sessionDetails="
            trainerCourseView.course && trainerCourseView.course.details[0]
          "
          :supportingImages="trainerCourseView.supporting_images"
          :average_rating="
            trainerCourseView.course && trainerCourseView.course.average_rating
          "
          :total_count="
            trainerCourseView.course && trainerCourseView.course.total_count
          "
          :batches="trainerCourseView.course"
          :sessions="trainerCourseView && trainerCourseView.sessions"
        />
      </section>
      <section>
        <ul class="flex items-center justify-between mb-4">
          <li>
            <select
              class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              v-model="isSessions"
            >
              <option :value="true">Classes</option>
              <!-- <option :value="false">History</option> -->
            </select>
          </li>

          <!-- <li v-if="isSessions == false">
            <router-link
              class="h-8 px-4 m-2 text-sm text-white transition-colors duration-150 bg-green-light ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-white hover:text-green-light py-2"
              :to="{
                name: 'CourseHistory',
                params: { id: this.$route.params.id },
              }"
              >See All</router-link
            >
          </li> -->
        </ul>

        <CourseSessionListCard
          :data="trainerCourseView.sessions"
          v-if="isSessions"
        />
        <!-- <CourseHistory :data="trainerCourseView.history.data || []" v-else /> -->
      </section>
    </section>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout.vue";
import SessionThumbnailSupporting from "@/components/trainer/SessionThumbnailSupporting";

import CourseSessionListCard from "@/components/CourseSessionListCard";
// import CourseHistory from "@/components/CourseHistory";

import { mapActions, mapGetters } from "vuex";
import { Pencil, Trash } from "@/components/icons";
import ConfirmationAlert from "@/components/user/ConfirmationAlert";

export default {
  name: "SingleCourse",
  components: {
    TrainerLayout,
    // CourseHistory,
    SessionThumbnailSupporting,
    CourseSessionListCard,
    Pencil,
    Trash,
    ConfirmationAlert,
  },
  data() {
    return {
      isSessions: true,
      deleteCoursePopUp: false,
      courseDeleteId: "",
      message: "",
    };
  },
  computed: {
    ...mapGetters(["trainerCourseView"]),
  },
  methods: {
    ...mapActions(["getTrainerCourseView", "getTrainerCourseDelete"]),

    handleCourseDel(id) {
      var w = "";
      if (this.trainerCourseView.sessions.length == 0) {
        w = "Warning: Are you sure you want to delete this Course?";
      } else {
        w =
          "Warning: This Course is currently active. Are you sure you want to delete?";
      }
      this.message = w;
      this.deleteCoursePopUp = true;
      this.courseDeleteId = id;
    },
    openConfrimDeletePopUp(val) {
      if (val) {
        this.getTrainerCourseDelete(this.courseDeleteId);
        this.$router.push({ name: "sessions", params: { id: "all" } });
      } else {
        this.deleteCoursePopUp = !this.deleteCoursePopUp;
      }
    },
  },
  created() {
    this.getTrainerCourseView({ id: this.$route.params.id });
  },
};
</script>